<!--=======================================
=            NAVEGATION DRAWER            =
========================================-->
<template>
  <v-container>
    <!-- HEADER -->
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Navigation Drawer</div>
      </base-header>
    </v-row>
    <!-- HEADER END-->
    <!-- analytc-progress -->
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Playground</div>
          <div slot="card-body">
            <v-container>
              <v-row justify="space-around">
                <v-col cols="12">
                  <v-select v-model="color" :items="colors" label="Color"></v-select>
                </v-col>

                <v-switch v-model="drawer" class="ma-2" label="v-model"></v-switch>

                <v-switch v-model="miniVariant" class="ma-2" label="Mini variant"></v-switch>

                <v-switch v-model="expandOnHover" class="ma-2" label="Expand on hover"></v-switch>

                <v-switch v-model="background" class="ma-2" label="Background"></v-switch>

                <v-switch v-model="right" class="ma-2" label="Right"></v-switch>
              </v-row>

              <v-card height="400" class="overflow-hidden">
                <v-navigation-drawer
                  v-model="drawer"
                  :color="color"
                  :expand-on-hover="expandOnHover"
                  :mini-variant="miniVariant"
                  :right="right"
                  :src="bg"
                  absolute
                  dark
                >
                  <v-list dense nav class="py-0">
                    <v-list-item two-line :class="miniVariant && 'px-0'">
                      <v-list-item-avatar>
                        <img src="https://randomuser.me/api/portraits/men/81.jpg" />
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>Application</v-list-item-title>
                        <v-list-item-subtitle>Subtext</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item v-for="item in items" :key="item.title" link>
                      <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-navigation-drawer>
              </v-card>
            </v-container>
          </div>
        </base-card>
      </v-col>

      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Colored drawer</div>
          <div slot="card-body">
            <v-card class="mx-auto" height="400" width="256">
              <v-navigation-drawer class="deep-purple accent-4" dark permanent>
                <v-list>
                  <v-list-item v-for="item in items" :key="item.title" link>
                    <v-list-item-icon>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <template v-slot:append>
                  <div class="pa-2">
                    <v-btn block>Logout</v-btn>
                  </div>
                </template>
              </v-navigation-drawer>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Permanent floating drawer</div>
          <div slot="card-body">
            <v-card class="pa-12" color="indigo darken-2" flat>
              <v-card elevation="12" width="256">
                <v-navigation-drawer floating permanent>
                  <v-list dense rounded>
                    <v-list-item v-for="item in items" :key="item.title" link>
                      <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-navigation-drawer>
              </v-card>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">MIni</div>
          <div slot="card-body">
            <v-card>
              <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini" permanent>
                <v-list-item class="px-2">
                  <v-list-item-avatar>
                    <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-title>John Leider</v-list-item-title>

                  <v-btn icon @click.stop="mini = !mini">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-list-item>

                <v-divider></v-divider>

                <v-list dense>
                  <v-list-item v-for="item in items" :key="item.title" link>
                    <v-list-item-icon>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-navigation-drawer>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Temporary</div>
          <div slot="card-body">
            <v-sheet height="400" class="overflow-hidden" style="position: relative;">
              <v-container class="fill-height">
                <v-row align="center" justify="center">
                  <v-btn color="pink" dark @click.stop="drawer = !drawer">Toggle</v-btn>
                </v-row>
              </v-container>

              <v-navigation-drawer v-model="drawer" absolute temporary>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>John Leider</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>

                <v-list dense>
                  <v-list-item v-for="item in items" :key="item.title" link>
                    <v-list-item-icon>
                      <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-navigation-drawer>
            </v-sheet>
          </div>
        </base-card>
      </v-col>

      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Expand on hover</div>
          <div slot="card-body">
            <div class="ma-12 pa-12">
              <template>
                <v-card>
                  <v-navigation-drawer permanent expand-on-hover>
                    <v-list>
                      <v-list-item class="px-2">
                        <v-list-item-avatar>
                          <v-img src="https://randomuser.me/api/portraits/women/85.jpg"></v-img>
                        </v-list-item-avatar>
                      </v-list-item>

                      <v-list-item link>
                        <v-list-item-content>
                          <v-list-item-title class="title">Sandra Adams</v-list-item-title>
                          <v-list-item-subtitle>sandra_a88@gmail.com</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-divider></v-divider>

                    <v-list nav dense>
                      <v-list-item link>
                        <v-list-item-icon>
                          <v-icon>mdi-folder</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>My Files</v-list-item-title>
                      </v-list-item>
                      <v-list-item link>
                        <v-list-item-icon>
                          <v-icon>mdi-account-multiple</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Shared with me</v-list-item-title>
                      </v-list-item>
                      <v-list-item link>
                        <v-list-item-icon>
                          <v-icon>mdi-star</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Starred</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-navigation-drawer>
                </v-card>
              </template>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Backgrounds</div>
          <div slot="card-body">
            <v-card class="mx-auto" height="300" width="300">
              <v-navigation-drawer
                absolute
                dark
                src="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
                width="100%"
                permanent
              >
                <v-list>
                  <v-list-item v-for="([icon, text], i) in items" :key="i" link>
                    <v-list-item-icon>
                      <v-icon>{{ icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                      <v-list-item-title>{{ text }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-navigation-drawer>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Combined drawers</div>
          <div slot="card-body">
            <v-card class="mx-auto" height="300" width="330">
              <v-navigation-drawer permanent width="100%">
                <v-row class="fill-height" no-gutters>
                  <v-navigation-drawer dark mini-variant mini-variant-width="56" permanent>
                    <v-list-item class="px-2">
                      <v-list-item-avatar>
                        <v-img src="https://randomuser.me/api/portraits/women/75.jpg"></v-img>
                      </v-list-item-avatar>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list dense nav>
                      <v-list-item v-for="item in items" :key="item.title" @click>
                        <v-list-item-action>
                          <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-navigation-drawer>

                  <v-list class="grow">
                    <v-list-item v-for="link in links" :key="link" link>
                      <v-list-item-title v-text="link"></v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-row>
              </v-navigation-drawer>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Bottom drawer</div>
          <div slot="card-body">
            <v-card class="mx-auto overflow-hidden" height="400" width="344">
              <v-system-bar color="deep-purple darken-3"></v-system-bar>

              <v-app-bar color="deep-purple accent-4" dark prominent>
                <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

                <v-toolbar-title>My files</v-toolbar-title>

                <v-spacer></v-spacer>

                <v-btn icon>
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon>mdi-filter</v-icon>
                </v-btn>

                <v-btn icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </v-app-bar>

              <v-navigation-drawer v-model="drawer" absolute bottom temporary>
                <v-list nav dense>
                  <v-list-item-group
                    v-model="group"
                    active-class="deep-purple--text text--accent-4"
                  >
                    <v-list-item>
                      <v-list-item-title>Foo</v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-title>Bar</v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-title>Fizz</v-list-item-title>
                    </v-list-item>

                    <v-list-item>
                      <v-list-item-title>Buzz</v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-navigation-drawer>

              <v-card-text>The navigation drawer will appear from the bottom on smaller size screens.</v-card-text>
            </v-card>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <!--  analytc-progress end -->
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";

export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      drawer: true,
      items: [
        { title: "Dashboard", icon: "mdi-view-dashboard" },
        { title: "Photos", icon: "mdi-image" },
        { title: "About", icon: "mdi-help-box" }
      ],
      color: "primary",
      colors: ["primary", "blue", "success", "red", "teal"],
      right: true,
      miniVariant: false,
      expandOnHover: false,
      background: false
    };
  },
  computed: {
    bg() {
      return this.background
        ? "https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg"
        : undefined;
    }
  }
};
</script>
<style scoped>
</style>
<!--====  End of NAVEGATION DRAWER  ====-->